<template>
  <el-dialog
    v-model="dialogOpen"
    width="500"
    align-center
    @close="toggleOpen(!props.dialogValue.open)"
  >
    <div class="dialog-connect-box">
      <!-- icons -->
      <div class="icons" v-if="store.project === 'sephora'">
        <i class="ico sephora-logo"><svg-icon name="sephora-logo" /></i>
        <i class="ico arrow"><svg-icon name="arrow-next" /></i>
        <svg-icon
          name="logo"
          :class="{ 'is-sephora': store.project === 'sephora' }"
        />
        <i class="ico arrow"><svg-icon name="arrow-next" /></i>
        <i class="ico black-logo"
          ><svg-icon :name="props.dialogValue.data.icon"
        /></i>
      </div>

      <div class="icons" v-if="store.project === 'cj'">
        <i class="ico cj-logo"><svg-icon name="cj-logo" /></i>
        <i class="ico arrow"><svg-icon name="arrow-next" /></i>
        <svg-icon name="logo" :class="{ 'is-cj': store.project === 'cj' }" />
        <i class="ico arrow"><svg-icon name="arrow-next" /></i>
        <i class="ico black-logo"
          ><svg-icon :name="props.dialogValue.data.icon"
        /></i>
      </div>

      <div class="icons" v-else-if="!isInvite && store.project !== 'sephora' && store.project !== 'cj'">
        <i class="ico black-logo"
          ><svg-icon :name="props.dialogValue.data.icon"
        /></i>
        <i v-if="props.dialogValue.step === 1" class="ico black-logo facebook"
          ><svg-icon name="facebook"
        /></i>
        <i class="ico arrow"><svg-icon name="arrow-next" /></i>
        <svg-icon
          name="logo"
          :class="{ 'is-sephora': store.project === 'sephora' }"
        />
      </div>

      <div class="icons" v-else-if="store.project !== 'sephora' && store.project !== 'cj'&& isInvite ">
        <el-image :src="RegisterStore.inviteBrand.brand_logo" fit="contain" />
        <i class="ico arrow"><svg-icon name="arrow-next" /></i>

        <svg-icon
          name="logo"
          :class="{ 'is-sephora': store.project === 'sephora' }"
        />
        <i class="ico arrow"><svg-icon name="arrow-next" /></i>

        <i class="ico black-logo"
          ><svg-icon :name="props.dialogValue.data.icon"
        /></i>
      </div>

      <!-- content -->
      <div class="col-connect-dialog">
        <h2 class="w-100" v-if="store.project === 'sephora'">
          Sephora uses Motom to connect to {{ props.dialogValue.data.name }}
        </h2>
        <h2 class="w-100" v-if="store.project === 'cj'">
          CJ uses Motom to connect to {{ props.dialogValue.data.name }}
        </h2>
        <h2 class="w-100" v-else-if="!isInvite && store.project !== 'sephora' && store.project !== 'cj'">
           Motom connects to {{ props.dialogValue.data.name }}
          Connect {{ props.dialogValue.data.name }}
        </h2>
        <h2 class="w-100" v-else-if="store.project !== 'sephora' && store.project !== 'cj' && isInvite ">
          {{ RegisterStore.inviteBrand.merchant_display_name }} uses Motom to
          connect to {{ props.dialogValue.data.name }}
        </h2>
        <h3
          class="w-100"
          v-if="
            props.dialogValue.step === 2 &&
            props.dialogValue.data.name === 'Instagram'
          "
        >
          Your Instagram account must be set to a
          <a href="https://help.instagram.com/2358103564437429" target="_blank"
            >Creator</a
          >
          or
          <a href="https://help.instagram.com/502981923235522" target="_blank"
            >Business</a
          >
          profile to proceed.
        </h3>

        <el-button
          class="ui-button--w100 margin-bottom-24"
          type="primary"
          size="large"
          @click="openDoubleCheck"
          v-if="store.project === 'sephora'"
          >Connect</el-button
        >

        <el-scrollbar class="scrollbar-content">
          <!-- for-fb -->
          <div v-if="props.dialogValue.step === 1">
            <p class="hint-text">
              Please connect your Facebook to Motom for Instagram insights. We
              use Instagram insights for your brand storefront opportunities.
            </p>

            <dl class="lists">
              <dt>
                Before connecting your Facebook on
                {{
                  store.project === "sephora"
                    ? "Sephora creator storefront"
                    : store.project === "cj"
                      ? "CJ creator storefront"
                      : "Motom"
                }},
              </dt>
              <dd>
                <i>1</i>
                Your Facebook account must have a public Facebook Page. This is
                different than a Facebook profile.
                <el-link
                  :underline="false"
                  href="https://support.motom.me/"
                  target="_blank"
                  >Learn more</el-link
                >.
              </dd>
              <dd>
                <i>2</i>
                That Facebook Page must be selected and connected to the
                Instagram profile.
                <el-link
                  :underline="false"
                  href="https://support.motom.me/"
                  target="_blank"
                  >Learn more</el-link
                >.
              </dd>
            </dl>
          </div>
          <!-- verified-box-->
          <div
            class="verified-text"
            :class="{ 'is-sephora': store.project === 'sephora' }"
          >
            <svg-icon name="verified" />
            <h3>
              This does not allow us to post on your behalf or access your
              private information.
            </h3>
            <p v-if="!isInvite">
              This connection allows us to access your basic information (such
              as your name and profile picture), your profile and content
              insights (such as engagement and follower demographics), and your
              published content to streamline your posting abilities on
              {{
                store.project === "sephora"
                  ? "Sephora creator storefront"
                  : "Motom"
              }}.
            </p>
            <p v-else>
              This connection allows us to access your basic information (such
              as your name and profile picture), your profile and content
              insights (such as engagement and follower demographics), as well
              as your published content to help you streamline adding content to
              and managing your
              {{ RegisterStore.inviteBrand.merchant_display_name }} creator
              storefront.
            </p>
          </div>

          <p class="cop" v-if="store.project === 'sephora'">
            Sephora's
            <a @click.stop="openTerms()">Terms of Use</a> &amp;
            <a @click.stop="openPrivacy()">Privacy Policy</a>. Subject to
            change.
          </p>

          <p class="cop" v-if="store.project === 'cj'">
            CJ's
            <a @click.stop="openTerms()">Terms of Use</a> &amp;
            <a @click.stop="openPrivacy()">Privacy Policy</a>. Subject to
            change.
          </p>

          <p class="cop">
            Motom's
            <a @click.stop="openTerms(true)">Terms of Use</a> &amp;
            <a @click.stop="openPrivacy(true)">Privacy Policy</a>. Subject to
            change.
          </p>
          <el-button
            v-if="store.project !== 'sephora'"
            class="ui-button--w100"
            type="primary"
            size="large"
            @click="openDoubleCheck"
            >Connect</el-button
          >
        </el-scrollbar>
      </div>
    </div>
  </el-dialog>

  <el-dialog
    v-model="dialogOpenDoubleCheck"
    width="420"
    align-center
    @close="dialogOpenDoubleCheck = false"
    class="dialog-double-check"
  >
    <h2>Do you have Instagram Creator or Instagram Business account?</h2>
    <h3>
      Your Instagram account must be set to a
      <a href="https://help.instagram.com/2358103564437429" target="_blank"
        >Creator</a
      >
      or
      <a href="https://help.instagram.com/502981923235522" target="_blank"
        >Business</a
      >
      profile to proceed.
    </h3>
    <div class="buttons">
      <el-button
        type="primary"
        size="large"
        @click="
          dialogOpenDoubleCheck = false;
          connectToSocial(props.dialogValue.data);
        "
        >Yes</el-button
      >
      <el-button type="text" size="large" @click="dialogOpenDoubleCheck = false"
        >No</el-button
      >
    </div>
  </el-dialog>
</template>

<script setup>
import { computed, ref } from "vue";
import { useGlobalStore } from "@/stores/GlobalStore";
import { v4 as uuidv4 } from "uuid";
import ajax from "@/utils/Ajax";
import { useRegisterStore } from "@/stores/RegisterStore";
import { useRoute } from "vue-router";
import emitter from "@shared/utils/EventBus";

const store = useGlobalStore();
const RegisterStore = useRegisterStore();
const props = defineProps({
  dialogValue: {
    default: () => ({
      open: false,
      data: null,
      step: 2, // move FB connect, only had step2 now (step1 is for fb connect)
    }),
    type: Object,
  },
  need_token: {
    default: false,
    type: Boolean,
  },
  is_more_register: {
    default: false,
    type: Boolean,
  },
  is_verifity: {
    default: false,
    type: Boolean,
  },
});
const dialogOpen = computed(() => props.dialogValue.open);
const dialogOpenDoubleCheck = ref(false);
const emit = defineEmits(["update:dialogValue"]);
const route = useRoute();

const isInvite = computed(
  () => route && route.name === "register" && RegisterStore.inviteBrand,
);
//+++++++++++++++++++++
//function
//+++++++++++++++++++++
const toggleOpen = (newOpenValue) => {
  const updatedValue = {
    ...props.dialogValue,
    open: newOpenValue,
  };
  if (!newOpenValue) {
    window.localStorage.removeItem("REATOR_PROTAL_new_add_social");
  }
  emit("update:dialogValue", updatedValue);
};

const openDoubleCheck = () => {
  //10439 kill this double check
  // if(props.dialogValue.step === 2 && props.dialogValue.data.name === 'Instagram'){
  //   dialogOpenDoubleCheck.value = true;
  // } else {
  connectToSocial(props.dialogValue.data);
  //}
};

const connectToSocial = (item) => {
  const createKey = uuidv4();
  const baseURL = ajax.defaults.baseURL.replace("/api/v1", "");
  const token = store.token || window.localStorage.getItem("token");
  const tokenValue = `${props.need_token && token ? `&token=${token}` : ""}`;

  //++++++++++++++++++++++++++++++++++
  if (props.is_more_register) {
    window.localStorage.setItem("CREATOR_PROTAL_is_more_social", true);
  }

  if (props.is_verifity) {
    window.localStorage.setItem("CREATOR_PROTAL_is_verifity", true);
  }
  //++++++++++++++++++++++++++++++++++

  store.loading = true;
  // motom on step 2-3/2-4 uses VeriftySocialFunction to process the key after redirect,
  // so skip the register-go-out marker that would re-trigger the initial match flow
  const isMotomSocialStep =
    store.project === 'motom' &&
    route?.name === 'register' &&
    (RegisterStore.step === '2-3' || RegisterStore.step === '2-4');

  // Save current step before redirect — Pinia state is lost after page reload
  if (isMotomSocialStep) {
    window.localStorage.setItem('CREATOR_PROTAL_motom_register_step', RegisterStore.step);
  }

  if (item.tag === "ig") {
    window.localStorage.setItem(
      "CREATOR_PROTAL_ig_social_key",
      JSON.stringify(createKey),
    );
    if (route?.name === "register" && !isMotomSocialStep) {
      window.localStorage.setItem(
        "REATOR_PROTAL_register_go_out",
        JSON.stringify(item),
      );
    }
    //connect_status=10or 15 is lite social
    let handleUrl =
      item.connect_status === 10 ||
      item.connect_status === 15 ||
      item.status === 10 ||
      item.status === 15
        ? "facebook_business"
        : "instagram";
    window.location.href = `${baseURL}/login/social/${handleUrl}?origin_url=${window.location.href}&cache_key=${createKey}${tokenValue}`;
  } else if (item.tag === "tk") {
    if (route?.name === "register" && !isMotomSocialStep) {
      window.localStorage.setItem(
        "REATOR_PROTAL_register_go_out",
        JSON.stringify(item),
      );
    }
    window.localStorage.setItem(
      "CREATOR_PROTAL_tk_social_key",
      JSON.stringify(createKey),
    );
    console.log(
      "window.location.href",
      `/login/social/tiktok_business?origin_url=${window.location.href}&cache_key=${createKey}${tokenValue}`,
    );
    window.location.href = `/login/social/tiktok_business?origin_url=${window.location.href}&cache_key=${createKey}${tokenValue}`;
  }
  // not yet
  else if (item.tag === "yt") {
    window.localStorage.setItem(
      "CREATOR_PROTAL_yt_social_key",
      JSON.stringify(createKey),
    );
    window.location.href = `${baseURL}/login/social/youtube?origin_url=${window.location.href}&cache_key=${createKey}${tokenValue}`;
    store.loading = false;
  }
};

const openPrivacy = (is_motom = false) => {
  if (store.project === "sephora" && !is_motom) {
    window.open("https://www.sephora.com/beauty/privacy-policy");
  } else if (store.project === "cj" && !is_motom) {
    window.open("https://www.cj.com/legal/privacy-policy-cjselect");
  } else {
    emitter.emit("open-global-drawer", "privacy-policy");
  }
};

const openTerms = (is_motom = false) => {
  if (store.project === "sephora" && !is_motom) {
    window.open("https://www.sephora.com/beauty/terms-of-use");
  } else if (store.project === "cj" && !is_motom) {
    window.open("https://www.cj.com/legal/terms");
  } else {
    emitter.emit("open-global-drawer", "terms-of-use");
  }
};
</script>

<style lang="scss">
.dialog-connect-box {
  .icons {
    @include flexCenter();
    justify-content: center;
    margin: 2vh auto;

    .svg-icon__logo {
      height: 82px;
      width: 82px;
      fill: var(--Brand-primary);

      &.is-sephora {
        fill: var(--Black-100);
      }
    }

    img {
      width: 82px;
      height: 82px;
      border-radius: 50%;
      overflow: hidden;
    }

    .ico {
      height: 82px;
      width: 82px;
      @include flexCenter();
      justify-content: center;
      border-radius: 100%;
      background: var(--Black-90);
      margin: 24px 0;

      &.sephora-logo {
        background: var(--Bg-01);

        svg {
          height: 80%;
          width: 80%;
          fill: var(--Black-100);
        }
      }

      svg {
        height: 50%;
        width: 50%;
        fill: var(--Black-00);

        &.svg-icon__arrow-next {
          width: 24px;
          height: 24px;
          fill: var(--Black-90);
        }
      }

      &.arrow {
        background: var(--Black-00);
        width: 16px;
        margin: 0 24px;
      }

      &.black-logo {
        background: var(--Black-100);
      }

      &.facebook {
        margin-left: -24px;
        z-index: 1;
      }
    }

    @media (max-width: $mobile_size) {
      .ico,
      .svg-icon__logo,
      img {
        width: 48px !important;
        height: 48px !important;
      }

      .ico {
        margin: 16px 0 !important;

        &.facebook {
          margin-left: -8px !important;
        }
      }
    }
  }

  .col-connect-dialog {
    display: block !important;
  }

  h2 {
    margin-bottom: 16px;
    font: var(--medium-20);
    text-align: center;
    color: var(--Text-primary);

    & + h3 {
      text-align: center;
      font: var(--medium-16) !important;
      color: var(--Text-primary);
      padding: 0 16px 16px;
    }
  }

  .scrollbar-content {
    max-height: calc(80vh - 170px);
    //height: calc(80vh - 170px);

    .hint-text {
      color: var(--Text-default);
      text-align: center;
    }

    .lists {
      margin: 16px 0;

      dt {
        font: var(--medium-14);
        color: var(--Text-secondary);
        margin-bottom: 8px;
        text-align: left;
      }

      dd {
        font: var(--medium-12);
        color: var(--Text-default);
        margin-bottom: 8px;
        padding-left: 28px;
        position: relative;
        text-align: left;

        a {
          font: var(--medium-12);
        }

        i {
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -10px;
          font-style: normal;
          font: var(--medium-12);
          color: var(--Black-00);
          height: 20px;
          line-height: 20px;
          width: 20px;
          text-align: center;
          border-radius: 50%;
          background-color: var(--PB-100);
        }
      }
    }

    .link-text {
      font: var(--medium-12);
      color: var(--Text-secondary);
      width: 100%;
      text-align: left;
      margin-bottom: 16px;

      a {
        font: var(--medium-12);
      }
    }

    .pop {
      padding-bottom: 24px;
      font-size: 10px;
      color: var(--Black-60);

      a {
        font-size: 10px;
      }
    }
  }

  .verified-text {
    margin-bottom: 16px;
    text-align: left;
    background-color: var(--Neu-20);
    padding: 16px 16px 16px 38px;
    position: relative;
    border-radius: 16px;

    &.is-sephora {
      background-color: var(--Bg-01);
    }

    svg {
      position: absolute;
      height: 14px;
      width: 14px;
      fill: var(--dark-blue);
      left: 16px;
      top: 17px;
    }

    h3 {
      font: var(--medium-14);
      color: var(--Black-100);
      margin: 0 0 8px;
    }

    p {
      font-size: 12px;
      color: var(--Black-80);
    }
  }

  .links {
    text-align: left;

    dt {
      font: var(--font-med-12);
      margin: 8px 0;
      color: var(--dark-blue);
    }

    dd {
      font: var(--font-med-12);
      margin: 8px 0;
    }
  }

  .cop {
    font-size: 12px;
    color: var(--Black-70);
    margin: 16px 0;
    text-align: left;

    & + .cop {
      position: relative;
      top: -10px;
    }
  }

  .instagram-item {
    display: block;
    margin: 8px 0;
    height: 48px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    border: 1px solid var(--Black-30);
    border-radius: 2px;
    cursor: pointer;

    &:hover {
      background-color: var(--light-neutral);
    }

    figure {
      height: 32px;
      width: 32px;
      position: relative;

      img {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        object-fit: cover;
        background-color: var(--Black-30);
      }

      i {
        position: absolute;
        right: -2px;
        bottom: -2px;
        height: 18px;
        width: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--black-90);
        border: 1px solid var(--white);
        border-radius: 50%;
        overflow: hidden;

        svg {
          height: 65%;
          width: 65%;
          fill: var(--white);
        }
      }
    }

    h3 {
      flex: 1;
      padding: 0 12px;
      font: var(--font-med-14);
      color: var(--dark-blue);

      span {
        color: var(--Black-60);
        padding-left: 8px;
      }
    }

    svg {
      height: 20px;
      width: 20px;
    }

    .expired {
      font: var(--font-med-14);
      color: var(--red);
      text-transform: uppercase;
      margin-left: 8px;
    }
  }

  .ui-scrollbar__wrap {
    max-height: calc(88vh - 32px - 200px);

    .ui-button--primary {
      position: sticky;
      bottom: 0;
    }
  }

  .margin-bottom-24 {
    margin-bottom: 24px;
  }
}

.dialog-double-check {
  h2 {
    font: var(--medium-20);
    color: var(--Text-primary);
  }

  h3 {
    font-size: 16px !important;
    font-weight: 400 !important;
    font-family: var(--font) !important;
    color: var(--Text-primary);
    padding: 16px 0;

    a {
      font-size: 16px !important;
      font-weight: 400 !important;
      font-family: var(--font) !important;
    }
  }

  .buttons {
    padding: 8px 0 0;

    .ui-button {
      width: 100%;
      display: flex;
      margin: 0;

      &:first-child {
        margin-bottom: 12px;
      }
    }
  }
}
</style>
